"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcProjectSelector = class UcProjectSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    fieldName;
    onField_name(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("fieldName");
    }
    clearable;
    onClearable(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("clearable");
    }
    projects;
    async $$load_projects() {
        return this.$fn.fetch('list_project');
    }
    messages;
    ux;
    dataMembers = ['projects', 'messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                projects: null,
                messages: {
                    searchPlaceholder: this.$fn.pgettext("Project", "Search for invoice"),
                },
                ux: null,
            },
        };
    }
    async act_7315092382398562_emit_8058_getActionArgs($event) {
        return {
            event: "optionSelected",
            value: $event.option,
        };
    }
    async evh_7315092382398562_optionSelected(event, scope) {
        return await this.actions.evh_7315092382398562_optionSelected.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_emit_8058 = new core_1.actions.EmitAction({
            actionArgs: this.act_7315092382398562_emit_8058_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_optionSelected_8057 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_emit_8058,
            event: "optionSelected",
            displayName: "emit",
        });
        const evh_7315092382398562_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_optionSelected_8057],
        });
        return {
            act_7315092382398562_emit_8058,
            evh_7315092382398562_optionSelected_8057,
            evh_7315092382398562_optionSelected,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcProjectSelector.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcProjectSelector.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "project",
    }),
    __metadata("design:type", String)
], UcProjectSelector.prototype, "fieldName", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fieldName'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcProjectSelector.prototype, "onField_name", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: true,
    }),
    __metadata("design:type", Boolean)
], UcProjectSelector.prototype, "clearable", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('clearable'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcProjectSelector.prototype, "onClearable", null);
UcProjectSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcProjectSelector);
exports.default = UcProjectSelector;
vue_property_decorator_1.Vue.component("UcProjectSelector", UcProjectSelector);
